const usePingLiveActivity = () => {};
export default usePingLiveActivity;
